




















import UpIcon from "../../assets/icons/Orion_arrow_up.svg";
import DownIcon from "../../assets/icons/Orion_arrow_down.svg";
import CloseIcon from "../../assets/icons/Orion_close.svg";
import AppForm from "../atoms/AppForm.vue";
import AppDatalist from "../atoms/AppDatalist.vue";
import AppKeyboardOption from "../atoms/AppKeyboardOption.vue";
import Vue, { PropType } from "vue";
export type Ingredient = {
  name: string;
  amount: string;
  unit: string;
};
export default Vue.extend({
  components: {
    UpIcon,
    DownIcon,
    CloseIcon,
    AppForm,
    AppDatalist,
    AppKeyboardOption
  },
  props: {
    ingredient: Object as PropType<Ingredient>,
    index: Number,
    isLast: Boolean,
    isEdit: Boolean
  },
  computed: {
    isFirst(): boolean {
      return this.index === 0;
    }
  },
  methods: {
    onDeleteItem(): void {
      this.$emit("on-delete-item");
    },
    onUpItem(): void {
      this.$emit("on-up-item");
    },
    onDownItem(): void {
      this.$emit("on-down-item");
    }
  }
});
